import React, { useEffect, useState } from 'react';
import { MenuItem, Select, InputLabel, TextField, Checkbox, ListItemIcon, ListItemText, Grid, Button, Input } from '@material-ui/core';
import { getToday } from "../utils/varialbles";
import { makeStyles } from '@material-ui/core/styles';
import http from "../services/httpService";
import { usePersistentState } from 'react-persistent-state'

let statusArray = { "I": 'Interested', "N": 'Not Interested', "L": 'Later', "O": 'No Answer', "S": 'No Status' }

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    table:
    {
        field: 'Resizing',
        title: 'Column Width',
        cellStyle: {
            whiteSpace: 'nowrap',
            width: '20%',
        },
    },
    indeterminateColor: {
        color: "#f50057"
    },
    selectAllText: {
        fontWeight: 500
    },
    selectedAll: {
        backgroundColor: "rgba(0, 0, 0, 0.08)",
        "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.08)"
        }
    },
    radio: {
        '&$checked': {
            color: '#57bf74'
        }
    },
    checked: {}

});

function Filter(props) {
    // (props, 'fcvg');

    const { clearFilter, setAppliedFilter, selectedColumns, filterState, setFilterState, filterList } = props.data;

    // const { selectedFilterData } = props.selectedFilter;
    // ('am props', props.data.filterState);
    // (filterState);
    // (setAppliedFilter);
    // (props, 'props');
    const classes = useStyles();
    const [testState, setTestState] = React.useState([]);

    const [isRange, setIsRange] = React.useState(false);


    //console uponchange
    useEffect(x => {



        // const storage = localStorage.getItem(JSON.parse("states"));
        let storage = JSON.parse(localStorage.getItem("states") || "[]");
        // setFilterList(storage)
        // let updateds = storage.JSON.parse(storage)
        // setFilterList(storage)
        // ('am storage', storage);

        storage.forEach((es) => {
            filterState.forEach((as) => {
                if (es.id === as.id) {
                    setFilterState(es)
                }
            })
        })

        // if (storage.length !== 0 && filterList.length !== 0) {
        //     // setFilterState(y => {
        //     storage.forEach((es) => {
        //         filterList.forEach((as) => {
        //             if (as.id === as.name) {
        //                 as.options.push(as)
        //                 ('am as', as);
        //             }
        //             else {
        //                 ('am as', as);
        //             }
        //         })
        //     })
        // }
        // else {
        //     ('am empty');
        // }

    }, [testState]);


    const closeFilter = (e) => {
        e.preventDefault();
        // ('filterClose');
        props.setOpen();
    }
    const applyFilter = () => {
        // ("filter");
        props.setOpen(false);

        const cleanedFilterState = filterState.filter(x => {
            if (x.options) { // for select and radios
                return x.options.length > 0
            } else if (x.data) { // for date
                return x.data.greaterThan || x.data.lessThan || x.data.equalTo || x.data.lessThanEqual || x.data.greaterThanEqual || x.data.range
            } else if (x.value) { // for number type
                //x.value is a number u cant get length of it
                return (x.value.toString()).length > 0
            }
            // (x);
        });

        localStorage.setItem("states", JSON.stringify(cleanedFilterState));
        setAppliedFilter(cleanedFilterState);

    }


    // const [filterState, setFilterState] = React.useState(generateEmptyFilterState());
    const updateFilter = (v, id, meta) => {

        // (meta);   
        if (v === 'range') {
            setIsRange(true);
        } else {
            // setIsRange(false);
        }
        ;

        setFilterState(fstate => {
            // ('am fstate', fstate);
            const newState = filterList.map(x => {
                // (x);

                //if this filter id is same as id received as prop
                if (x.id === id) {
                    //check the type and add value according to the value.
                    // if(x.type === 'number'){
                    //     return ({
                    //         name: x.name,
                    //         id: x.id,
                    //         value: parseFloat(v),
                    //         // options: v
                    //     })
                    // }

                    if (x.type === 'select') {
                        return ({
                            name: x.name,
                            id: x.id,
                            options: v
                        })
                    } else if (x.type === 'radio') {
                        return ({
                            name: x.name,
                            id: x.id,
                            options: [v]
                        })
                    } else if (x.type === 'date' || x.type === 'number') {
                        if (meta === 'option') {
                            const fstateObject = fstate.find(filter => filter.id === x.id);
                            let currentValue = fstateObject.data.lessThan ? fstateObject.data.lessThan : "";
                            currentValue = fstateObject.data.greaterThan ? fstateObject.data.greaterThan : "";
                            currentValue = fstateObject.data.equalTo ? fstateObject.data.equalTo : "";
                            currentValue = fstateObject.data.greaterThanEqual ? fstateObject.data.greaterThanEqual : "";
                            currentValue = fstateObject.data.lessThanEqual ? fstateObject.data.lessThanEqual : "";
                            currentValue = fstateObject.data.range ? fstateObject.data.range : "";
                            // (currentValue);
                            return ({ id, name: x.name, data: { [v]: currentValue } })
                        } else if (meta === 'value') {
                            const fstateObject = fstate.find(filter => filter.id === x.id);
                            const currentOption = Object.keys(fstateObject.data)[0];
                            return ({ id, name: x.name, data: { [currentOption]: v } })
                        } else if (meta === 'rangeFrom') {
                            const fstateObject = fstate.find(filter => filter.id === x.id);
                            const currentOption = Object.keys(fstateObject.data)[0];
                            const currentValue = fstateObject.data[Object.keys(fstateObject.data)[0]];
                            if (currentValue.includes(',')) {
                                const fromValue = currentValue.split(',')[0];
                                const toValue = currentValue.split(',')[1];
                                const encodedDate = `${v},${toValue}`;
                                // ({currentValue, v, fromValue, toValue, encodedDate});
                                return ({ id, name: x.name, data: { [currentOption]: encodedDate } })
                            } else {
                                const encodedDate = `${v},`;
                                // (currentValue, v, encodedDate)
                                return ({ id, name: x.name, data: { [currentOption]: encodedDate } })
                            }
                        } else if (meta === 'rangeTo') {
                            const fstateObject = fstate.find(filter => filter.id === x.id);
                            const currentOption = Object.keys(fstateObject.data)[0];
                            const currentValue = fstateObject.data[Object.keys(fstateObject.data)[0]];
                            if (currentValue.includes(',')) {
                                const fromValue = currentValue.split(',')[0];
                                const toValue = currentValue.split(',')[1];
                                const encodedDate = `${fromValue},${v}`;
                                // ({currentValue, v, fromValue, toValue, encodedDate});
                                return ({ id, name: x.name, data: { [currentOption]: encodedDate } })
                            } else {
                                const encodedDate = `,${v}`;
                                // (currentValue, v, encodedDate)
                                return ({ id, name: x.name, data: { [currentOption]: encodedDate } })
                            }
                        }
                    }
                } else {
                    return fstate.find(filter => filter.id === x.id);
                }
            })
            // (newState, 'am new state');
            return newState;
        });
    }

    useEffect(x => {
        // ('am fil', filterState);

    }, [filterState]);



    // (filterList);

    const shouldNameDisplay = (filter) => {
        // const exceptionCase = location.url
        return filter.showName ? filter.name : ""
    }

    const parseRangeValue = (doubleDate, fromTo) => {
        // value={parseRangeValue(filterState.find(x=>x.id===filter.id)?.data[Object.keys(filterState.find(x=>x.id===filter.id)?.data || {})[0]])}
        // doubleDate Format is 2020-05-30,2020-07-31
        // (doubleDate)
        // (doubleDate.split(',')[0])
        if (fromTo === 'from') {
            return doubleDate.split(',')[0];
        } else {
            return doubleDate.split(',')[1];
        }
    }

    return (
        <div className={["newfilterstyle", "menupopupfilter", "filter"].join(" ")} style={{ display: props.isMenuOpen ? "block" : "none" }}>

            <div style={{ width: 30, height: 30, borderRadius: '50%', lineHeight: '30px', display: 'flex', justifyContent: 'center', fontWeight: 'bold', cursor: 'pointer', background: '#ddd', margin: '5px 0 0 5px' }}

                onClick={closeFilter}>X</div>
            {
                filterList.map((filter, index) => {
                    return (<div key={index} style={{ marginLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                        <div>
                            <InputLabel style={{ color: "black" }} >{shouldNameDisplay(filter)}</InputLabel>
                        </div>


                        <div style={{ paddingTop: 10 }}>
                            {
                                filter.type === "select" ?
                                    <>

                                        <Select
                                            displayEmpty
                                            value={filterState.find(x => { return x.id === filter.id })?.options || []}
                                            onChange={e => { updateFilter(e.target.value, filter.id) }}
                                            name={filter.name}
                                            className="select"
                                            variant='outlined'
                                            multiple={true}
                                            renderValue={
                                                (selected) => {
                                                    return (
                                                        selected.map(s => filter.options.find(x => x.value === s)?.name).join(', ')
                                                    )
                                                }
                                            }
                                            style={{
                                                backgroundColor: "white"
                                            }}
                                        >
                                            <MenuItem value="">Select</MenuItem>
                                            {
                                                filter.options.map((option, index) => {
                                                    return (
                                                        <MenuItem key={index} value={option.value}>
                                                            <ListItemText primary={option.name} />
                                                            <ListItemIcon>

                                                                <Checkbox classes={{ root: classes.radio, checked: classes.checked }}
                                                                    checked={filterState.find(x => x.id === filter.id)?.options.indexOf(option.value) !== -1 ? true : false}
                                                                />
                                                            </ListItemIcon>
                                                        </MenuItem>
                                                    )

                                                })
                                            }
                                        </Select>
                                    </> :
                                    filter.type === "radio" ?
                                        <>
                                            <Select
                                                displayEmpty
                                                value={filterState.find(x => { return x.id === filter.id })?.options}
                                                onChange={e => { updateFilter(e.target.value, filter.id) }}
                                                name={filter.name}
                                                className="select"
                                                variant='outlined'
                                                multiple={false}
                                                style={{
                                                    backgroundColor: "white"
                                                }}
                                            >
                                                <MenuItem value="">Select</MenuItem>
                                                {
                                                    filter.options.map((option, index) => {
                                                        return (
                                                            <MenuItem key={index} value={option.value}>
                                                                <ListItemText primary={option.name} />
                                                            </MenuItem>
                                                        )

                                                    })
                                                }
                                            </Select>
                                        </> :
                                        filter.type === "date" ?
                                            <>
                                                <select
                                                    value={Object.keys(filterState.find(x => { return x.id === filter.id })?.data || {})[0]}
                                                    onChange={x => updateFilter(x.target.value, filter.id, "option")}
                                                    className="select"
                                                    label={filter.name}
                                                    style={{
                                                        backgroundColor: "white",
                                                        marginBottom: 10
                                                    }}
                                                >
                                                    <option value={"equalTo"} >Equal To</option>
                                                    <option value={"lessThan"} >Less Than</option>
                                                    <option value={"greaterThan"} >Greater Than</option>
                                                    <option value={"lessThanEqual"} >Less Than Equal To</option>
                                                    <option value={"greaterThanEqual"} >Greater Than Equal To</option>
                                                    <option value={"range"} >Range</option>

                                                </select>
                                                {/* {// ('test1', filter.id)}
                                    {// (filterState.find(x=>{// (x);return x.id===filter.id}))}
                                    {// ('test2')} */}
                                                {
                                                    Object.keys(filterState.find(x => { return x.id === filter.id })?.data || {})[0] !== 'range' ?
                                                        (
                                                            <TextField
                                                                type="date"
                                                                variant="outlined"
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                }}
                                                                value={filterState.find(x => x.id === filter.id)?.data[Object.keys(filterState.find(x => x.id === filter.id)?.data || {})[0]]}
                                                                onChange={x => updateFilter(x.target.value, filter.id, "value")}
                                                                className="select"
                                                                style={{
                                                                    backgroundColor: "white"
                                                                }}
                                                            />
                                                        ) :
                                                        // RANGE FIELDS
                                                        (
                                                            <>
                                                                <label style={{ fontSize: 11, marginBorrom: 10, display: 'block' }}> From </label>
                                                                <TextField
                                                                    type="date"
                                                                    variant="outlined"
                                                                    InputLabelProps={{
                                                                        shrink: true,
                                                                    }}
                                                                    value={parseRangeValue(filterState.find(x => x.id === filter.id)?.data[Object.keys(filterState.find(x => x.id === filter.id)?.data || {})[0]], 'from')}
                                                                    onChange={x => updateFilter(x.target.value, filter.id, "rangeFrom")}
                                                                    className="select"
                                                                    style={{
                                                                        backgroundColor: "white"
                                                                    }}
                                                                />
                                                                <label style={{ fontSize: 11, marginBorrom: 10, display: 'block' }}> To </label>
                                                                <TextField
                                                                    type="date"
                                                                    variant="outlined"
                                                                    InputLabelProps={{
                                                                        shrink: true,

                                                                    }}
                                                                    value={parseRangeValue(filterState.find(x => x.id === filter.id)?.data[Object.keys(filterState.find(x => x.id === filter.id)?.data || {})[0]], 'to')}
                                                                    onChange={x => updateFilter(x.target.value, filter.id, "rangeTo")}
                                                                    className="select"
                                                                    style={{
                                                                        backgroundColor: "white"
                                                                    }}
                                                                />
                                                            </>
                                                        )
                                                }
                                            </> :
                                            filter.type === "number" ?
                                                <>
                                                    <select
                                                        value={Object.keys(filterState.find(x => { return x.id === filter.id })?.data || {})[0]}
                                                        onChange={x => updateFilter(x.target.value, filter.id, "option")}
                                                        className="select"
                                                        label={filter.name}
                                                        style={{
                                                            backgroundColor: "white",
                                                            marginBottom: 10
                                                        }}
                                                    >
                                                        <option value={"equalTo"} >Equal To</option>
                                                        <option value={"lessThan"} >Less Than</option>
                                                        <option value={"greaterThan"} >Greater Than</option>
                                                        <option value={"lessThanEqual"} >Less Than Equal To</option>
                                                        <option value={"greaterThanEqual"} >Greater Than Equal To</option>
                                                        <option value={"range"} >Range</option>

                                                    </select>
                                                    {/* {// ('test1', filter.id)}
                                    {// (filterState.find(x=>{// (x);return x.id===filter.id}))}
                                    {// ('test2')} */}
                                                    {
                                                        Object.keys(filterState.find(x => { return x.id === filter.id })?.data || {})[0] !== 'range' ?
                                                            (
                                                                <TextField
                                                                    type="text"
                                                                    variant="outlined"
                                                                    InputLabelProps={{
                                                                        shrink: true,
                                                                    }}
                                                                    value={filterState.find(x => x.id === filter.id)?.data[Object.keys(filterState.find(x => x.id === filter.id)?.data || {})[0]]}
                                                                    onChange={x => updateFilter(x.target.value, filter.id, "value")}
                                                                    className="select"
                                                                    style={{
                                                                        backgroundColor: "white"
                                                                    }}
                                                                />
                                                            ) :
                                                            // RANGE FIELDS
                                                            (
                                                                <>
                                                                    <label style={{ fontSize: 11, marginBorrom: 10, display: 'block' }}> From </label>
                                                                    <TextField
                                                                        type="text"
                                                                        variant="outlined"
                                                                        InputLabelProps={{
                                                                            shrink: true,
                                                                        }}
                                                                        value={parseRangeValue(filterState.find(x => x.id === filter.id)?.data[Object.keys(filterState.find(x => x.id === filter.id)?.data || {})[0]], 'from')}
                                                                        onChange={x => updateFilter(x.target.value, filter.id, "rangeFrom")}
                                                                        className="select"
                                                                        style={{
                                                                            backgroundColor: "white"
                                                                        }}
                                                                    />
                                                                    <label style={{ fontSize: 11, marginBorrom: 10, display: 'block' }}> To </label>
                                                                    <TextField
                                                                        type="text"
                                                                        variant="outlined"
                                                                        InputLabelProps={{
                                                                            shrink: true,

                                                                        }}
                                                                        value={parseRangeValue(filterState.find(x => x.id === filter.id)?.data[Object.keys(filterState.find(x => x.id === filter.id)?.data || {})[0]], 'to')}
                                                                        onChange={x => updateFilter(x.target.value, filter.id, "rangeTo")}
                                                                        className="select"
                                                                        style={{
                                                                            backgroundColor: "white"
                                                                        }}
                                                                    />
                                                                </>
                                                            )
                                                    }
                                                </> : ""
                            }
                        </div>
                    </div>)
                })
            }
            <div style={{ float: "right", paddingBottom: 10, paddingRight: 40, paddingTop: 10, display: "flex", justifyContent: "flex-end", columnGap: 20 }}>
                <Button variant='contained' onClick={clearFilter} color="default">Clear</Button>
                <Button variant='contained' onClick={applyFilter} color="primary">Apply</Button>
            </div>
        </div>)
}


const generateEmptyFilterState = (filterList) => {
    // ('uhhh', filterList)
    const filterState = [];
    // let storage = JSON.parse(localStorage.getItem("states") || "[]");
    // // setFilterList(storage)
    // filterState.push(storage)

    // set_temp_dynamic_names({
    //     dynamicSelect_one: '',
    //     dynamicSelect_two : ''
    // });
    // ('filter state', filterList);


    filterList.map(x => {
        if (x.type === 'select' || x.type === 'radio') {
            // alert(1)
            const emptyFilterObject = {
                id: x.id,
                options: []
            }
            filterState.push(emptyFilterObject);
        } else if (x.type === 'date' || x.type === 'number') {
            // var today = new Date(); 
            const emptyFilterObject = {
                id: x.id,
                data: {
                    equalTo: ""
                }
            }
            filterState.push(emptyFilterObject);
        }
        // else if(x.type === 'number') {
        //     const emptyFilterObject = {
        //         id: x.id,
        //         value: ""
        //     }
        //     filterState.push(emptyFilterObject);
        // } 
        else {
            //throw an error
            throw new Error("Invalid filter type")
        }
    })
    return filterState;
}

const useFilter = (url) => {
    const [filterState, setFilterState] = useState([]);
    // (filterState);

    const [filterList, setFilterList] = useState([]);
    // ('bhb', filterList);
    useEffect(() => {
        // http.get(url+'-filter').then(res=>{
        //     setFilterState(generateEmptyFilterState(res.data));
        //     setFilterList(res.data);
        // })
        setFilterState(generateEmptyFilterState(filterList));


        // ('am store', filterList, filterState);
        // .sort((a, b) => a.lname.localeCompare(b.lname))

    }, [filterList])
    useEffect(x => {
        // (filterState);

    }, [filterState]);
    // const getFilteredRows = (rows) => {

    // }

    // const [appliedFilter, setAppliedFilter] = usePersistentState([]);
    const [appliedFilter, setAppliedFilter] = useState([]);



    // const applyFilter = () => {
    //     setAppliedFilter(filterState);
    // }

    const [filterString, setFilterString] = React.useState("");
    useEffect(x => {
        // ({appliedFilter});

        if (appliedFilter !== 0) {
            appliedFilter.map(x => {
                if (x.type === 'select' || x.type === 'radio') {
                    const selectFilerobject = {
                        id: x.id,
                        options: [x.options]
                    }
                    filterState.push(selectFilerobject);

                }
                else if (x.type === 'date' || x.type === 'number') {
                    // var today = new Date(); 
                    const emptyFilterObject = {
                        id: x.id,
                        data: {
                            equalTo: ""
                        }
                    }
                    filterState.push(emptyFilterObject);
                }

            })
        }



        setFilterString(getFilterParams());
    }, [appliedFilter])

    const clearFilter = () => {
        // setFilterState(generateEmptyFilterState(filterList));filterState
        // (filterList);
        setFilterState(generateEmptyFilterState(filterList));
        setAppliedFilter([]);
    }

    const generateFilterList = (fl) => {
        setFilterList(x => {
            //generate a random 10 alpha numeric string as id
            return fl.map(x => ({ ...x, id: Math.random().toString(36).substr(2, 10) }))
        })
    } // check

    // const generateFilterList = x=>x; //devs


    const getFilterParams = () => {
        //convert the appliedFilterState to query params string (without ? mark) using the following convertion format
        // status - comma separated values, name is Status in the object
        // RM - comma separated values, name is RM Name in the object
        // signup_lt - less than signup date - date format, name is Signup Date and lessThan property is present with date
        // signup_gt - greater than signup date -date format, name is SignupDate and greaterThan property is present with date
        // getback_lt - less than get back date - date format, name is Get Back Date and lessThan property is present with date
        // getback_gt - greater than get back date -date format name is Get Back Date and greaterThan property is present with date
        // convert appliedFilterState to query params string
        // appliedFilterState contains objects with properties: name, options[ARRAY] (or data[OBJECT] for time)

        const conversionFormatFor_select = {
            "RM Name": "RM",
            // "RM name": "rm_name", // This is commenting for Prospect Overview Filter Fix
            "BGT Name": "bgt_name",
            "Status": "status",
            "Prospect Source": "psource",
            "Service Type": "serviceType",
            "Referee Visits": "refree_visits",
            "Successful referrals": "success_refs",
            "Referrals Shared": "ref_shared",
            "Referral Bonus": "ref_bonus",
            "Country": "country",
            "Issue Type": "issueType",
            "Reporter": "reporter",
            "Assigned To": "assignedTo",
            "Severity": "severity",
            "Frequency": "frequency",
            "Preferred Language": "language",
            "Critical CDT Reminders": "ccdtReminders",
            "Subscription Status": "subscription_status",
            "Conditions": "filter_data",
            "KYC Status": "kyc_status",
            // "Personal profile Status": "pp_status",
            "Personal Profile Status": "pp_status",
            "Demat Link": "demat_link",
            "Task Status": "task_status",
            "City": "city",
            "State": "state"

        }
        const conversionFormatFor_date = {
            "Expiry Date": "expiryDate_",
            "Signup Date": "signup_",
            // "Sign up date": "signup_", // This is commenting for Prospect Overview Filter Fix
            "Get Back Date": "getback_",
            "Created Date": "createdDate_",
            "Call Date": "callDate_",
            "Date Time": "callDate_",
            // "Referrals Shared": "ref_shared_",
            "Renewal Date": "renewaldt_",
            "Subscription Date": "subdt_",
            "Last login date": "lastlogin_",// This is commenting for Investment Overview Filter Fix
            "Last Login Date": "lastlogin_",
            "Goals set": "goals_set_value_",
            "ref_shared_value": "ref_shared_value_",
            "ref_bonus_value": "ref_bonus_value_",
            "refree_visits_value": "refree_visits_value_",
            "success_refs_value": "success_refs_value_",
            "Goals set": "goals_set_",

            "Investment Amount": "invamount_",

        }
        const conversionFormatFor_number = {
            // "Goals set" : "goals_set_value_"
            // "ref_shared_value": "ref_shared_value",
            // "ref_bonus_value" : "ref_bonus_value",
            // "refree_visits_value": "refree_visits_value",
            // "success_refs_value": "success_refs_value"

        }

        const filterParams = {};
        // (filterParams);
        appliedFilter.map(filter => {
            if (filter.options) { // condition it based on type of filter rather than options or data props
                // (filter.options);
                // (filter);
                // (filter.options.map(x=>x))
                // (filter.options.map(x=>x).join(','))
                filterParams[conversionFormatFor_select[filter.name]] = filter.options.map(x => x).join(',');

            } else if (filter.data) {
                let suffix;
                if (Object.keys(filter.data)[0] === 'greaterThan') {
                    suffix = "gt"
                } else if (Object.keys(filter.data)[0] === 'lessThan') {
                    suffix = 'lt'
                } else if (Object.keys(filter.data)[0] === 'equalTo') {
                    suffix = 'et';
                } else if (Object.keys(filter.data)[0] === 'lessThanEqual') {
                    suffix = 'lte';
                } else if (Object.keys(filter.data)[0] === 'greaterThanEqual') {
                    suffix = 'gte';
                } else if (Object.keys(filter.data)[0] === 'range') {
                    suffix = 'range';
                }
                // (filter);
                // (Object.keys(filter.data)[0]);
                filterParams[conversionFormatFor_date[filter.name] + suffix] = filter.data[Object.keys(filter.data)[0]];
            }
            else if (filter.value) {
                filterParams[conversionFormatFor_number[filter.name]] = filter.value;
            }
        })
        //return the query string with the filterParams
        // (("&"+Object.keys(filterParams).map(x=>x+"="+filterParams[x]).join('&')));
        const params = Object.keys(filterParams).map(x => x + "=" + filterParams[x]).join('&')
        return (params ? "&" + params : "");
    }

    // (getFilterParams());

    // const PassedFilter = ({data:{setFilterList, getFilterParams, appliedFilter}})=><Filter filterList={filterList} appliedFilter={appliedFilter} setAppliedFilter={setAppliedFilter} filterState={filterState} setFilterState={setFilterState} clearFilter={clearFilter}/>
    // const PassedFilter = x=><Filter filterList={filterList} appliedFilter={appliedFilter} setAppliedFilter={setAppliedFilter} filterState={filterState} setFilterState={setFilterState} clearFilter={clearFilter}/>

    // return [
    //     clearFilter,
    //     filterString, setAppliedFilter,
    //     filterState, setFilterState,
    //     filterList, generateFilterList,
    //     Filter, 
    //     getFilterParams,
    // ]
    const passData = { clearFilter, setAppliedFilter, filterState, setFilterState, filterList }
    //setFilterList, Filter, filterString, 
    //forwardProps: {clearFilter, setAppliedFilter, filterState, setFilterState, filterList }

    const passFilters = generateFilterList; // syntax sugar
    return [
        Filter,
        filterString,
        passFilters,
        passData,

    ]

    // return [
    //     clearFilter,
    //     filterString, setAppliedFilter,
    //     filterState, setFilterState,
    //     filterList, generateFilterList
    //     Filter, 
    //     getFilterParams,
    // ]
}

export default useFilter;